// src/pages/SignupPage.jsx
import React, { useState } from 'react';
import {
  createUserWithEmailAndPassword,
  signInWithPopup,
  updateProfile,
  // sendEmailVerification
} from 'firebase/auth';
import { auth, googleProvider, db } from '../firebase';
import { setDoc, doc, serverTimestamp } from 'firebase/firestore';
import { theme } from '../utils/constants';

export default function SignupPage({ navigateTo }) {

  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const validatePhone = (number) => {
    return /^\+?[0-9]{9,15}$/.test(number);
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      setLoading(false);
      return;
    }

    if (!validatePhone(phone)) {
      setError("Enter a valid phone number (9–15 digits, optional + country code).");
      setLoading(false);
      return;
    }

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Update display name
      await updateProfile(user, {
        displayName: fullName
      });

      // Optional email verification (disabled for now)
      /*
      await sendEmailVerification(user);
      */

      // Create Firestore profile
      await setDoc(doc(db, "users", user.uid), {
        fullName,
        email,
        phone,
        role: "customer",
        createdAt: serverTimestamp()
      });

      navigateTo('shop');

    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleSignup = async () => {
    setLoading(true);
    setError('');

    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;

      // Create or merge Firestore profile
      await setDoc(doc(db, "users", user.uid), {
        fullName: user.displayName || "",
        email: user.email,
        phone: "",
        role: "customer",
        createdAt: serverTimestamp()
      }, { merge: true });

      navigateTo('shop');

    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section style={{ padding: '6rem 24px', background: theme.bgLight, minHeight: '80vh' }}>
      <div style={{
        maxWidth: '480px',
        margin: '0 auto',
        background: 'white',
        padding: '3rem',
        borderRadius: '16px',
        boxShadow: theme.shadowMd
      }}>

        <h1 style={{
          textAlign: 'center',
          fontFamily: "'Roboto Slab', serif",
          marginBottom: '2rem'
        }}>
          Create Account
        </h1>

        {error && (
          <p style={{ color: 'red', textAlign: 'center', marginBottom: '1rem' }}>
            {error}
          </p>
        )}

        <form onSubmit={handleSignup}>

          <input
            type="text"
            placeholder="Full Name"
            value={fullName}
            onChange={e => setFullName(e.target.value)}
            required
            style={inputStyle}
          />

          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            style={inputStyle}
          />

          <input
            type="tel"
            placeholder="Phone Number (e.g. +260977123456)"
            value={phone}
            onChange={e => setPhone(e.target.value)}
            required
            style={inputStyle}
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            style={inputStyle}
          />

          <input
            type="password"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            required
            style={{ ...inputStyle, marginBottom: '1.5rem' }}
          />

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '1rem',
              background: theme.primary,
              color: 'white',
              border: 'none',
              borderRadius: '50px',
              fontWeight: 600,
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.7 : 1
            }}
          >
            {loading ? 'Creating...' : 'Sign Up'}
          </button>
        </form>

        <div style={{
          textAlign: 'center',
          margin: '1.5rem 0',
          color: theme.textLight
        }}>
          or
        </div>

        <button
          onClick={handleGoogleSignup}
          disabled={loading}
          style={{
            width: '100%',
            padding: '1rem',
            background: '#4285F4',
            color: 'white',
            border: 'none',
            borderRadius: '50px',
            fontWeight: 600,
            cursor: loading ? 'not-allowed' : 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '12px'
          }}
        >
          <img
            src="https://www.google.com/favicon.ico"
            alt="Google"
            style={{ width: '20px', height: '20px' }}
          />
          Sign Up with Google
        </button>

        <p style={{ textAlign: 'center', marginTop: '2rem' }}>
          Already have an account?{' '}
          <span
            onClick={() => navigateTo('login')}
            style={{ color: theme.primary, cursor: 'pointer', fontWeight: 600 }}
          >
            Login
          </span>
        </p>

      </div>
    </section>
  );
}

const inputStyle = {
  width: '100%',
  padding: '1rem',
  marginBottom: '1rem',
  borderRadius: '8px',
  border: '1px solid #ddd'
};
// // src/pages/SignupPage.jsx
// import React, { useState } from 'react';
// import {
//   createUserWithEmailAndPassword,
//   signInWithPopup,
//   updateProfile,
//   // sendEmailVerification  // 👈 Commented out for now
// } from 'firebase/auth';
// import { auth, googleProvider, db } from '../firebase';
// import { setDoc, doc, serverTimestamp } from 'firebase/firestore';
// import { theme } from '../utils/constants';

// export default function SignupPage({ navigateTo }) {

//   const [fullName, setFullName] = useState('');
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [confirmPassword, setConfirmPassword] = useState('');
//   const [error, setError] = useState('');
//   const [loading, setLoading] = useState(false);

//   const handleSignup = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError('');

//     if (password !== confirmPassword) {
//       setError("Passwords do not match.");
//       setLoading(false);
//       return;
//     }

//     try {
//       const userCredential = await createUserWithEmailAndPassword(auth, email, password);
//       const user = userCredential.user;

//       // Update display name
//       await updateProfile(user, {
//         displayName: fullName
//       });

//       // ✅ Email verification (disabled for now)
//       /*
//       await sendEmailVerification(user);
//       */

//       // Create Firestore profile
//       await setDoc(doc(db, "users", user.uid), {
//         fullName,
//         email,
//         role: "customer",
//         createdAt: serverTimestamp()
//       });

//       navigateTo('shop');

//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleGoogleSignup = async () => {
//     setLoading(true);
//     setError('');

//     try {
//       const result = await signInWithPopup(auth, googleProvider);
//       const user = result.user;

//       // Create/merge Firestore profile
//       await setDoc(doc(db, "users", user.uid), {
//         fullName: user.displayName,
//         email: user.email,
//         role: "customer",
//         createdAt: serverTimestamp()
//       }, { merge: true });

//       navigateTo('shop');

//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <section style={{ padding: '6rem 24px', background: theme.bgLight, minHeight: '80vh' }}>
//       <div style={{
//         maxWidth: '480px',
//         margin: '0 auto',
//         background: 'white',
//         padding: '3rem',
//         borderRadius: '16px',
//         boxShadow: theme.shadowMd
//       }}>

//         <h1 style={{
//           textAlign: 'center',
//           fontFamily: "'Roboto Slab', serif",
//           marginBottom: '2rem'
//         }}>
//           Create Account
//         </h1>

//         {error && (
//           <p style={{ color: 'red', textAlign: 'center', marginBottom: '1rem' }}>
//             {error}
//           </p>
//         )}

//         <form onSubmit={handleSignup}>

//           <input
//             type="text"
//             placeholder="Full Name"
//             value={fullName}
//             onChange={e => setFullName(e.target.value)}
//             required
//             style={{
//               width: '100%',
//               padding: '1rem',
//               marginBottom: '1rem',
//               borderRadius: '8px',
//               border: `1px solid ${theme.border}`
//             }}
//           />

//           <input
//             type="email"
//             placeholder="Email"
//             value={email}
//             onChange={e => setEmail(e.target.value)}
//             required
//             style={{
//               width: '100%',
//               padding: '1rem',
//               marginBottom: '1rem',
//               borderRadius: '8px',
//               border: `1px solid ${theme.border}`
//             }}
//           />

//           <input
//             type="password"
//             placeholder="Password"
//             value={password}
//             onChange={e => setPassword(e.target.value)}
//             required
//             style={{
//               width: '100%',
//               padding: '1rem',
//               marginBottom: '1rem',
//               borderRadius: '8px',
//               border: `1px solid ${theme.border}`
//             }}
//           />

//           <input
//             type="password"
//             placeholder="Confirm Password"
//             value={confirmPassword}
//             onChange={e => setConfirmPassword(e.target.value)}
//             required
//             style={{
//               width: '100%',
//               padding: '1rem',
//               marginBottom: '1.5rem',
//               borderRadius: '8px',
//               border: `1px solid ${theme.border}`
//             }}
//           />

//           <button
//             type="submit"
//             disabled={loading}
//             style={{
//               width: '100%',
//               padding: '1rem',
//               background: theme.primary,
//               color: 'white',
//               border: 'none',
//               borderRadius: '50px',
//               fontWeight: 600,
//               cursor: loading ? 'not-allowed' : 'pointer',
//               opacity: loading ? 0.7 : 1
//             }}
//           >
//             {loading ? 'Creating...' : 'Sign Up'}
//           </button>
//         </form>

//         <div style={{
//           textAlign: 'center',
//           margin: '1.5rem 0',
//           color: theme.textLight
//         }}>
//           or
//         </div>

//         <button
//           onClick={handleGoogleSignup}
//           disabled={loading}
//           style={{
//             width: '100%',
//             padding: '1rem',
//             background: '#4285F4',
//             color: 'white',
//             border: 'none',
//             borderRadius: '50px',
//             fontWeight: 600,
//             cursor: loading ? 'not-allowed' : 'pointer',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             gap: '12px'
//           }}
//         >
//           <img
//             src="https://www.google.com/favicon.ico"
//             alt="Google"
//             style={{ width: '20px', height: '20px' }}
//           />
//           Sign Up with Google
//         </button>

//         <p style={{ textAlign: 'center', marginTop: '2rem' }}>
//           Already have an account?{' '}
//           <span
//             onClick={() => navigateTo('login')}
//             style={{ color: theme.primary, cursor: 'pointer', fontWeight: 600 }}
//           >
//             Login
//           </span>
//         </p>

//       </div>
//     </section>
//   );
// }
// // src/pages/SignupPage.jsx
// import React, { useState } from 'react';
// import { createUserWithEmailAndPassword, signInWithPopup } from 'firebase/auth';
// import { auth, googleProvider } from '../firebase';
// import { theme } from '../utils/constants';

// export default function SignupPage({ navigateTo }) {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [error, setError] = useState('');
//   const [loading, setLoading] = useState(false);

//   const handleSignup = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError('');
//     try {
//       await createUserWithEmailAndPassword(auth, email, password);
//       navigateTo('shop');
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleGoogleSignup = async () => {
//     setLoading(true);
//     setError('');
//     try {
//       await signInWithPopup(auth, googleProvider);
//       navigateTo('shop');
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <section style={{ padding: '6rem 24px', background: theme.bgLight, minHeight: '80vh' }}>
//       <div style={{ maxWidth: '480px', margin: '0 auto', background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: theme.shadowMd }}>
//         <h1 style={{ textAlign: 'center', fontFamily: "'Roboto Slab', serif", marginBottom: '2rem' }}>
//           Create Account
//         </h1>

//         {error && <p style={{ color: 'red', textAlign: 'center', marginBottom: '1rem' }}>{error}</p>}

//         <form onSubmit={handleSignup}>
//           <input
//             type="email"
//             placeholder="Email"
//             value={email}
//             onChange={e => setEmail(e.target.value)}
//             required
//             style={{ width: '100%', padding: '1rem', marginBottom: '1rem', borderRadius: '8px', border: `1px solid ${theme.border}` }}
//           />
//           <input
//             type="password"
//             placeholder="Password"
//             value={password}
//             onChange={e => setPassword(e.target.value)}
//             required
//             style={{ width: '100%', padding: '1rem', marginBottom: '1.5rem', borderRadius: '8px', border: `1px solid ${theme.border}` }}
//           />

//           <button
//             type="submit"
//             disabled={loading}
//             style={{
//               width: '100%',
//               padding: '1rem',
//               background: theme.primary,
//               color: 'white',
//               border: 'none',
//               borderRadius: '50px',
//               fontWeight: 600,
//               cursor: loading ? 'not-allowed' : 'pointer',
//               opacity: loading ? 0.7 : 1
//             }}
//           >
//             {loading ? 'Creating...' : 'Sign Up'}
//           </button>
//         </form>

//         <div style={{ textAlign: 'center', margin: '1.5rem 0', color: theme.textLight }}>or</div>

//         <button
//           onClick={handleGoogleSignup}
//           disabled={loading}
//           style={{
//             width: '100%',
//             padding: '1rem',
//             background: '#4285F4',
//             color: 'white',
//             border: 'none',
//             borderRadius: '50px',
//             fontWeight: 600,
//             cursor: loading ? 'not-allowed' : 'pointer',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             gap: '12px'
//           }}
//         >
//           <img src="https://www.google.com/favicon.ico" alt="Google" style={{ width: '20px', height: '20px' }} />
//           Sign Up with Google
//         </button>

//         <p style={{ textAlign: 'center', marginTop: '2rem' }}>
//           Already have an account?{' '}
//           <span
//             onClick={() => navigateTo('login')}
//             style={{ color: theme.primary, cursor: 'pointer', fontWeight: 600 }}
//           >
//             Login
//           </span>
//         </p>
//       </div>
//     </section>
//   );
// }